
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Low_Bid_Individual = class Notification_Low_Bid_Individual {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _outbid_modal_init_ind = false;
    static _outbid_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let affected_tracts = [];
        let lost_lead = false;
        let gained_lead = false;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.affected_tracts) {
                affected_tracts = meta.affected_tracts;
            }
            if (meta.lost_lead) {
                lost_lead = meta.lost_lead;
            }
            if (meta.gained_lead) {
                gained_lead = meta.gained_lead;
            }

        } catch (e) {
        }

        // Button handlers.
        if (!_.Notification_Outbid._outbid_modal_init_ind) {
            _.Notification_Outbid._outbid_modal_init_ind = true;
            _.on_ui_update_once("#ac-modal-low-bid-individual-btn-close", function () {
                $(this).click(function () {
                    _.Modal.close_unhidable();
                })
            });
        }

        function populate_list(auctionItems) {
            let $checkboxContainer = $(".ac-modal-low-bid-individual-items ul");
            $checkboxContainer.empty();

            auctionItems.forEach(item => {
                // let round = await item.auction_round.fetch_private();
                let item_text = item.title + " - " + item.acres + " " + _.property_noun_unit_plural_plusminus();

                let $label = $('<label>')
                    .css('width', '100%')
                    .css('height', '100%')
                    .css('text-align', 'center')
                    .css('cursor', 'pointer')
                    .attr('class', 'list-item-multiselect-styling')
                    .text(item_text)
                    .on('click', function () {
                        _.Modal.close_unhidable();
                        _.AuctionUI.set_current_item(item.id);
                    });

                let $li = $("<li class='list-group-item'></li>").append($label);

                $checkboxContainer.append($li);
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                // do {
                _.Notification_Outbid._outbid_modal_action = null;

                let deferred = $.Deferred();

                $("#ac-modal-low-bid-individual").data('deferred', deferred);

                // Get available items
                let auction_items = [];

                for (const item of (await _.ac_state.auction.auction_items.fetch_private())) {
                    let round = await item.auction_round.fetch_private();
                    if (round.current_bid_id) {
                        let bid = await round.current_bid.fetch_private();
                        if (bid.registrant_id == _.ac_state.registrant.id) {
                            auction_items.push(item);
                        }
                    }
                }

                populate_list(auction_items);

                $(".ac-modal-low-bid-individual-items-lost-lead").set_conditional_visibility(lost_lead);
                $(".ac-modal-low-bid-individual-items-gained-lead").set_conditional_visibility(gained_lead);

                $("#ac-modal-low-bid-individual").modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {

    }
}